import styled from 'styled-components';

export const TestimonialHome = styled.div`
  margin: ${(props) => (props.isParentingPage ? '20px 0 50px' : '50px 0')};
  position: relative;
  padding: ${(props) => (props.padding ? '20px 7.5%' : '0 7.5%')};
  background: linear-gradient(
    to bottom,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );

  @media (max-width: 720px) {
    margin: 10px 0;
    padding: 16px 0;
  }
`;

export const RelativeDiv = styled.div`
  position: relative;
`;

export const TestiImgContainer = styled.div`
  padding: 0 12px;
  flex-shrink: 0;
`;
